import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { isValid } from '../../../../../../../utils/validationSummary';
import { withTranslation } from 'react-i18next';

class PropertyDropdownUnlabeled extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            dropdownValue: ''
        };

        this.handleChange = this.handleChange.bind(this);
    }

    renderDropdownItems() {

        let dropdownItems = [];

        this.props.properties.forEach(prop => {
            dropdownItems.push(
                <Dropdown.Item onClick={this.handleChange} name={prop.key} key={prop.key} >{this.getDisplayValue(prop.key)}</Dropdown.Item>
            );
        });

        return dropdownItems;

    }

    handleChange(e) {
        const value = e.target.name;

        this.props.handleChange(this.props.property.info.name, value);
    }

    transformToValue(value) {
        for (let i = 0; i < this.props.properties.length; i++) {
            if (this.props.properties[i].key === +value) {
                return this.props.properties[i].value;
            }
        }
    }

    getDisplayValue(value) {
        const { t } = this.props;
        var v = value
        if(this.props.translate && value !== undefined && value !== null && typeof(v) === 'string')
            v = t(value.replaceAll(' ', '_'));

        const valueTemp = this.transformToValue(v);
        return this.props.propertyDisplayFunc && valueTemp !== undefined && valueTemp !== null
            ? this.props.propertyDisplayFunc(valueTemp)
            : valueTemp;
    }

    render() {

        const className = `edit-icon-project-header dropdown-inventronics ${isValid(this.props.validationSummary, this.props.property) ? '' : 'danger'}`;

        const displayValue = this.getDisplayValue(this.props.property.value);

        return (
            <Dropdown>
                <Dropdown.Toggle variant="secondary" style={{ marginLeft: "0" }} disabled={this.props.disabled} className={className}>{displayValue}</Dropdown.Toggle>
                <Dropdown.Menu style={{ minWidth: "auto", fontSize: "1rem" }}>
                    {this.renderDropdownItems()}
                </Dropdown.Menu>
            </Dropdown>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
    };
};

const mapDispatchToProps = {
}

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps),
    withTranslation()
)(PropertyDropdownUnlabeled);
